module.exports = __webpack_public_path__ + "static/media/partner6.80c464db.jpg";